import { render, staticRenderFns } from "./contentmenu.vue?vue&type=template&id=b4eb8dae&"
import script from "./contentmenu.vue?vue&type=script&lang=js&"
export * from "./contentmenu.vue?vue&type=script&lang=js&"
import style0 from "./contentmenu.vue?vue&type=style&index=0&id=b4eb8dae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports